import React from 'react';
import PropTypes from 'prop-types';
import {
  PAPER_TABS,
  Spacing_Base,
  FontSize_Css_Plus,
} from '../../../data/common';
import { strParse } from '../../../lib/util';

function BTypeTestRow({ vocaList = {}, startNo, tab, config }) {
  // const onlyFirstMeaing = config?.onlyFirstMeaning.includes('B');
  // console.log('vocabList B:', vocaList);
  return (
    <div
      style={{
        width: '100%',
        marginTop: `${config?.spacing * Spacing_Base}px`,
        fontFamily: "'Pretendard', Arial, sans-serif",
      }}
    >
      {tab !== PAPER_TABS.ANSWER && (
        <div
          style={{
            fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
            fontWeight: 700,
            fontFamily: "'Pretendard', Arial, sans-serif",
          }}
        >
          ※&nbsp;{vocaList?.title}
        </div>
      )}
      <div>
        {vocaList?.questions?.map((voca, idx) => {
          return (
            <div
              key={`${voca.questions}-${String(idx)}`}
              style={{
                display: 'grid',
                gridTemplateColumns: '1.2fr 4.5fr 4.5fr',
                justifyContent: 'space-between',
                alignItems: 'start',
                width: '100%',
                marginTop: `${config?.spacing * Spacing_Base}px`,
                fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
                fontFamily: "'Pretendard', Arial, sans-serif",
              }}
            >
              <div style={{ minWidth: '10px' }}>{startNo + idx}.</div>
              {(tab === PAPER_TABS.TEST_PAPER ||
                tab === PAPER_TABS.ANSWER_TEST_PAPER) && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                    gap: '3px',
                    paddingRight: '4px',
                    fontFamily: "'Pretendard', Arial, sans-serif",
                  }}
                >
                  <div
                    style={{ fontFamily: "'Pretendard', Arial, sans-serif" }}
                  >
                    {strParse(voca.question)}
                  </div>
                </div>
              )}
              <div
                style={{
                  midWidth: '100px',
                  minHeight: '18px',
                  textAlign: tab === PAPER_TABS.ANSWER ? 'left' : 'center',
                }}
              >
                <div
                  style={{
                    minHeight: '15px',
                    fontFamily: "'Pretendard', Arial, sans-serif",
                  }}
                >
                  {tab === PAPER_TABS.TEST_PAPER && ''}
                  {tab === PAPER_TABS.TEST_PAPER &&
                    config?.vocaFirstWordShow && (
                      <div style={{ width: '100%', textAlign: 'left' }}>
                        {voca?.answer[0]}
                      </div>
                    )}
                  {(tab === PAPER_TABS.ANSWER_TEST_PAPER ||
                    tab === PAPER_TABS.ANSWER) &&
                    voca.answer}
                </div>
                {(tab === PAPER_TABS.TEST_PAPER ||
                  tab === PAPER_TABS.ANSWER_TEST_PAPER) && (
                  <div
                    style={{
                      borderBottom: '1px solid #000',
                      width: '100%',
                      minWidth: '100px',
                    }}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

BTypeTestRow.propTypes = {
  tab: PropTypes.string.isRequired,
  config: PropTypes.object,
  vocaList: PropTypes.object,
  startNo: PropTypes.number,
};

export default BTypeTestRow;
